import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=cb19f660&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"
import style0 from "@/styles/views/MainPage/MainPage.less?vue&type=style&index=0&id=cb19f660&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb19f660",
  null
  
)

export default component.exports